<template>
  <div>
    <div class="Fuell-Toolbar">
      <div>
        <h3
          class="Fuell-Toolbar--subtitle"
          for="read-more"
        > {{$t('company_details_transaction_fields_subtitle')}}</h3>
      </div>

    </div>

    <div class="Fuell-Section">
      <div class="Fuell-Toolbar small">
        <h3
          class="Fuell-Section--title"
          v-t="{ path: 'company_details_default_fields_title' }"
        ></h3>
      </div>

      <div class="Fuell-List">
        <div
          class="Fuell-List--item"
          role="button"
          @click="handleCategoriesEdition()"
        >
          <div class="Fuell-List--item-title">
            {{$t('company_details_categories_and_subcategories')}}
          </div>
          <div class="Fuell-List--item-description"> {{$t('company_details_categories_and_subcategories_description')}}</div>
          <button class="Fuell-List--item-icon">
            <img
              alt="icon-open-categories"

              :src="require('@/assets/img/icons/icon-arrow-right.svg')"
            />
          </button>
        </div>

        <div
          class="Fuell-List--item"
          role="button"
          @click="showRequiredFieldsSettingsModal"
        >
          <div class="Fuell-List--item-title">
            {{$t('company_details_fields_settings_required_fields')}}
          </div>
          <div class="Fuell-List--item-description">{{$t('company_details_fields_settings_required_fields_description')}}</div>
          <button class="Fuell-List--item-icon">
            <img  alt="icon-open-required-fields" :src="require('@/assets/img/icons/icon-arrow-right.svg')" />
          </button>
        </div>
        <div
          class="Fuell-List--item"
          role="button"
          @click="handleAlerts()"
        >
          <div class="Fuell-List--item-title">{{$t('company_details_fields_settings_alerts')}}</div>
          <div class="Fuell-List--item-description">{{$t('company_details_fields_settings_alerts_description')}}</div>
          <button class="Fuell-List--item-icon">
            <img alt="icon-open-alerts" :src="require('@/assets/img/icons/icon-arrow-right.svg')" />
          </button>
        </div>
        <div
          class="Fuell-List--item"
          role="button"
          @click="handlePaymentMethods"
        >
          <div class="Fuell-List--item-title">{{$t('company_details_fields_settings_payment_methods')}}</div>
          <div class="Fuell-List--item-description">{{$t('company_details_fields_settings_payment_methods_description')}}</div>
          <button class="Fuell-List--item-icon">
            <img alt="icon-open-payment-methods" :src="require('@/assets/img/icons/icon-arrow-right.svg')" />
          </button>
        </div>
        <div
          class="Fuell-List--item"
          role="button"
          @click="handleCardsSchedule"
        >
          <div class="Fuell-List--item-title">{{$t('company_details_fields_settings_cards_schedule')}}</div>
          <div class="Fuell-List--item-description">{{$t('company_details_fields_settings_company_details_fields_settings_cards_schedule_description')}}</div>
          <button class="Fuell-List--item-icon">
            <img alt="icon-open-card-schedule" :src="require('@/assets/img/icons/icon-arrow-right.svg')" />
          </button>
        </div>

      </div>
    </div>

    <div class="Fuell-Section">
      <div class="Fuell-Toolbar small">
        <h3
          class="Fuell-Section--title"
          v-t="{ path: 'company_details_add_fields' }"
        ></h3>

        <button
          v-if="!isBookKeeper"
          class="Fuell-ToolbarButton ml-auto blue"
          @click="showCreateTransactionFieldModal"
        >
          <span
            class="Fuell-ToolbarButton--label"
            v-t="{ path: 'company_details_new_field_button' }"
          >
          </span>
        </button>
      </div>
    </div>
    <div class="custom-transaction-fields-section">
      <transaction-fields-table
        @editCustomField="editCustomField"
        @deleteCustomField="deleteCustomField"
      ></transaction-fields-table>
    </div>
    <div class="Fuell-Section">
      <div class="Fuell-Toolbar small">
        <h3 class="Fuell-Section--title">{{$t('company_funnel_aproval_flow_section_header')}}</h3>

        <button
          class="Fuell-ToolbarButton ml-auto blue"
          @click="showCreateFunnelAprovalFlowModal"
        >
          <span
            class="Fuell-ToolbarButton--label"
            @click="showCreateFunnelAprovalFlowModal"
          >
            {{$t('company_funnel_aproval_flow_create_flow')}}
          </span>
        </button>
      </div>
      <div><span class="Fuell-Text">{{$t('company_funnel_aproval_flow_info')}}</span></div>
    </div>

    <div class="pb-5">
      <funnel-aproval-flows-table @openReviewFunnelDetail="showCreateFunnelAprovalFlowModal" />
    </div>
    <div class="pb-5"></div>

    <transition name="slither">
      <categories-and-subcategories-modal
      :open.sync="showCategoriesAndSubcategoriesModal"
        @close="showCategoriesAndSubcategoriesModal = false"
        v-if="showCategoriesAndSubcategoriesModal"
      >
      </categories-and-subcategories-modal>
    </transition>
    <payment-methods-modal
      :open.sync="showPaymentMethodsModalFlag"
      v-if="showPaymentMethodsModalFlag"
    ></payment-methods-modal>
    <alerts-modal
      :open.sync="showAlertsModalFlag"
      v-if="showAlertsModalFlag"
    ></alerts-modal>
    <create-transaction-field-modal
      :customFieldId="customFieldToEdit"
      :open.sync="showCreateTransactionFieldModalFlag"
      @showConfirmModal="showConfirmModal"
      v-if="showCreateTransactionFieldModalFlag"
    ></create-transaction-field-modal>
    <required-fields-settings-modal
      v-if="showRequiredFieldsSettingsModalFlag"
      :open.sync="showRequiredFieldsSettingsModalFlag"
    > </required-fields-settings-modal>
    <create-funnel-aproval-flow-modal
      v-if="showCreateFunnelAprovalFlowModalFlag"
      :open.sync="showCreateFunnelAprovalFlowModalFlag"
      :reviewFunnelId="reviewFunnelToEdit"
    />
    <cards-schedule-modal
      :open.sync="showCardsScheduleModalFlag"
      v-if="showCardsScheduleModalFlag"
    ></cards-schedule-modal>
    <confirm-modal
      :open.sync="showConfirmModalFlag"
      :message="'company_update_transactions_transactions_affected_warning'"
      @accept="createCustomField"
      v-if="showConfirmModalFlag"
    >
    </confirm-modal>

  </div>
</template>

<script>
import TransactionFieldsTable from '../../_components/transaction_fields/TransactionFieldsTable'
import FunnelAprovalFlowsTable from '../../_components/transaction_fields/funnel_flows/FunnelAprovalFlowsTable'

const CategoriesAndSubcategoriesModal = () => import('../../_components/transaction_fields/CategoriesAndSubcategoriesModal')
const CreateTransactionFieldModal = () => import('../../_components/transaction_fields/CreateTransactionFieldModal')
const PaymentMethodsModal = () => import('../../_components/payment_methods/PaymentMethodsModal')
const RequiredFieldsSettingsModal = () => import('../../_components/transaction_fields/RequiredFieldsSettingsModal')
const AlertsModal = () => import('../../_components/alerts_configuration/AlertsModal')
const CreateFunnelAprovalFlowModal = () => import('../../_components/transaction_fields/funnel_flows/CreateFunnelAprovalFlowModal')
const CardsScheduleModal = () => import('../../_components/cards_schedule/CardsScheduleModal')
const ConfirmModal = () => import('@/components/Commons/ConfirmModal')

export default {
  name: 'TransactionFieldsIndex',
  components: {
    AlertsModal,
    CategoriesAndSubcategoriesModal,
    TransactionFieldsTable,
    FunnelAprovalFlowsTable,
    CreateTransactionFieldModal,
    CreateFunnelAprovalFlowModal,
    ConfirmModal,
    RequiredFieldsSettingsModal,
    PaymentMethodsModal,
    CardsScheduleModal
  },
  data () {
    return {
      showCategoriesAndSubcategoriesModal: false,
      showCreateTransactionFieldModalFlag: false,
      showPaymentMethodsModalFlag: false,
      showCardsScheduleModalFlag: false,
      showRequiredFieldsSettingsModalFlag: false,
      showCreateFunnelAprovalFlowModalFlag: false,
      showConfirmModalFlag: false,
      showAlertsModalFlag: false,
      customFieldToEdit: 0,
      customFieldToUpdate: {},
      reviewFunnelToEdit: 0,
      reviewFunnelToUpdate: {}
    }
  },
  computed: {
    isBookKeeper () {
      return this.$store.getters['LoginStore/isBookKeeper']
    }
  },
  methods: {
    closeModals () {
      this.showCardsScheduleModalFlag = false
      this.showRequiredFieldsSettingsModalFlag = false
      this.showCreateFunnelAprovalFlowModalFlag = false
      this.showAlertsModalFlag = false
      this.showCategoriesAndSubcategoriesModal = false
      this.showCreateTransactionFieldModalFlag = false
      this.showPaymentMethodsModalFlag = false
    },
    handlePaymentMethods () {
      this.closeModals()
      this.showPaymentMethodsModalFlag = true
    },
    handleCategoriesEdition () {
      this.closeModals()
      this.showCategoriesAndSubcategoriesModal = true
    },
    handleAlerts () {
      this.closeModals()
      this.showAlertsModalFlag = true
    },
    handleCardsSchedule () {
      this.closeModals()
      this.showCardsScheduleModalFlag = true
    },
    showCreateTransactionFieldModal () {
      this.closeModals()
      this.customFieldToEdit = 0
      this.showCreateTransactionFieldModalFlag = true
    },
    showCreateFunnelAprovalFlowModal (event) {
      this.closeModals()
      if (event) {
        this.reviewFunnelToEdit = event.id
        this.reviewFunnelToUpdate = event
      }
      this.showCreateFunnelAprovalFlowModalFlag = true
    },
    showRequiredFieldsSettingsModal () {
      this.closeModals()
      this.showRequiredFieldsSettingsModalFlag = true
    },
    async fetchTransactionFields () {
      await this.$store.dispatch('CompanyStore/TransactionFieldsStore/fetchTransactionFields')
    },
    async fetchReviewFlows () {
      await this.$store.dispatch('CompanyStore/TransactionFieldsStore/fetchReviewFlows')
    },
    editCustomField (event) {
      this.closeModals()
      this.customFieldToEdit = event
      this.showCreateTransactionFieldModalFlag = true
    },
    showConfirmModal (event) {
      this.customFieldToUpdate = event
      this.showConfirmModalFlag = true
    },
    async createCustomField (event) {
      let customField = {}

      Object.keys(this.customFieldToUpdate).forEach(key => {
        if (this.customFieldToUpdate[key]) {
          customField[key] = this.customFieldToUpdate[key]
        }
      })
      if (customField.includeBudgets.length > 0) {
        customField.includeBudgets = customField.includeBudgets.map(el => { return { id: el.id } })
      }
      if (customField.requireBudgets.length > 0) {
        customField.requireBudgets = customField.requireBudgets.map(el => { return { id: el.id } })
      }

      if (customField.includeInTransactionTypes.length > 0) {
        customField.includeInTransactionTypes = customField.includeInTransactionTypes.map(el => el.code)
      }
      await this.$store.dispatch('CompanyStore/TransactionFieldsStore/updateTransactionField', customField)
      this.showCreateTransactionFieldModalFlag = false
    },
    async deleteCustomField (event) {
      await this.$store.dispatch(
        'CompanyStore/TransactionFieldsStore/deleteTransactionField',
        event
      )
    }
  },
  async created () {
    this.fetchTransactionFields()
    this.fetchReviewFlows()
  }
}
</script>

<style>
.Fuell-List {
  max-width: 550px;
}
.custom-transaction-fields-section {
  padding-bottom: 30px;
}
</style>
<style scoped>
@media screen and (max-width: 576px) {
}
</style>
